<script setup>
/**
 * Per-page commercial/CTA block (ТЗ §4). When the page has its own unique
 * `commercial_block` HTML we render that; otherwise we fall back to whatever
 * default CTA the page passes via the slot (e.g. the shared referral / prize
 * banners) so no page loses its call to action before Phase 3 populates the
 * per-page copy. Rendered after the editorial content, kept visually compact.
 */
defineProps({
    html: { type: [String, null], default: null },
});
</script>

<template>
    <div v-if="html"
         class="mt-6 rounded-lg bg-slate-100 dark:bg-slate-800 px-4 py-3 text-base leading-relaxed text-slate-700 dark:text-slate-200 article-commercial"
         v-html="html">
    </div>
    <slot v-else/>
</template>
